import React from "react";
import PropTypes from "prop-types";
import {
    Form,
    FormGroup,
    Label,
    Input,
    Col,
    Button,
} from "reactstrap";

/**
 * Common Settings Edit Form Component
 */
const CommonSettingsEditForm = ({
    store_domain,
    is_campaign_links,
    is_coupon_blocker,
    is_smart_discount,
    onInputChange,
    onSubmit,
}) => {

    console.log("CommonSettingsEditForm", store_domain, is_campaign_links, is_coupon_blocker, is_smart_discount);
    return (
        <Form onSubmit={onSubmit}>
            <FormGroup className="row mb-4">
                <Label
                    htmlFor="horizontal-store_domain-Input"
                    className="col-sm-2 col-form-label text-md-right"
                    style={{ textAlign: "center" }}
                >
                    Store Domain
                </Label>
                <Col sm={4}>
                    <Input
                        value={store_domain}
                        type="text"
                        name="store_domain"
                        className="form-control"
                        id="horizontal-store_domain-Input"
                        readOnly
                    />
                </Col>
            </FormGroup>
            <FormGroup className="row mb-4">
                <Label
                    htmlFor="horizontal-campaign_links-Input"
                    className="col-sm-2 col-form-label text-md-right"
                    style={{ textAlign: "center" }}
                >
                    Campaign Links
                </Label>
                <Col sm={4}>
                    <div className="form-check form-switch">
                        <Input
                            type="checkbox"
                            name="is_campaign_links"
                            className="form-check-input"
                            id="horizontal-campaign_links-Input"
                            onChange={onInputChange}
                            checked={is_campaign_links}
                        />
                    </div>
                </Col>
            </FormGroup>
            <FormGroup className="row mb-4">
                <Label
                    htmlFor="horizontal-coupon-blocker-Input"
                    className="col-sm-2 col-form-label text-md-right"
                    style={{ textAlign: "center" }}
                >
                    Coupon Blocker
                </Label>
                <Col sm={4}>
                    <div className="form-check form-switch">
                        <Input
                            type="checkbox"
                            name="is_coupon_blocker"
                            className="form-check-input"
                            id="horizontal-coupon-blocker-Input"
                            onChange={onInputChange}
                            checked={is_coupon_blocker}
                        />
                    </div>
                </Col>
            </FormGroup>
            <FormGroup className="row mb-4">
                <Label
                    htmlFor="horizontal-smart-discount-Input"
                    className="col-sm-2 col-form-label text-md-right"
                    style={{ textAlign: "center" }}
                >
                    Smart Discount
                </Label>
                <Col sm={4}>
                    <div className="form-check form-switch">
                        <Input
                            type="checkbox"
                            name="is_smart_discount"
                            className="form-check-input"
                            id="horizontal-smart-discount-Input"
                            onChange={onInputChange}
                            checked={is_smart_discount}
                        />
                    </div>
                </Col>
            </FormGroup>
            <FormGroup className="row mb-4 justify-content-end">
                <Col sm={10}>
                    <div>
                        <Button
                            type="submit"
                            color="primary"
                            className="w-md"
                        >
                            Update
                        </Button>
                    </div>
                </Col>
            </FormGroup>
        </Form>
    );
};

CommonSettingsEditForm.propTypes = {
    store_domain: PropTypes.string.isRequired,
    is_campaign_links: PropTypes.bool.isRequired,
    is_coupon_blocker: PropTypes.bool.isRequired,
    is_smart_discount: PropTypes.bool.isRequired,
    onInputChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default CommonSettingsEditForm;

